var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloorplan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 11H12.75C11.7835 11 11 11.7835 11 12.75V26.75C11 27.7165 11.7835 28.5 12.75 28.5H26.75C27.7165 28.5 28.5 27.7165 28.5 26.75V12.75C28.5 11.7835 27.7165 11 26.75 11Z",
    stroke: "#0E0333",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 17.5278V15.75M11.75 17.5278C11.75 17.5278 15.4069 17.5278 17.75 17.5278H11.75ZM17.75 17.5278V19.75V17.5278Z",
    stroke: "#0E0333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.75V15.75V19.75",
    stroke: "#0E0333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 24.5H28.625V23H27.875V24.5ZM17.75 23C17.3358 23 17 23.3358 17 23.75C17 24.1642 17.3358 24.5 17.75 24.5V23ZM27.875 23H17.75V24.5H27.875V23Z",
    fill: "#0E0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorplan);
export default __webpack_public_path__ + "static/media/floorplan.9f0dd22881adf28f04c6326dd2ab9121.svg";
export { ForwardRef as ReactComponent };